module.exports = __webpack_public_path__ + "img/avatar-s-19.697c72c8.jpg";